<template>
  <div class="wrapper">
    <Header></Header>
    <!--/.global-header-->

    <div class="main">
      <!--【メインコンテンツここから】-->

      <div class="breadcrumbs">
        <ul>
          <li>ログイン</li>
        </ul>
      </div>
      <!--/.breadcrumbs-->

      <div class="login-visual">
        <img :src="`@/${getImgLoginVisualPath()}`" alt="" />
        <img :src="`@/${getImgLoginCapPath()}`" alt="ジェイメックは、導入後の「安心」をサポートします。" class="login-visual-caption" />
      </div>

      <div class="content-box">
        <p class="al-center">
          お客様と私たちのつながりは、製品だけでは終わりません。<br />ご購入後、治療の現場で有効にお使いいただけるように。<br />全ては患者さまの満足を得るために。<br />私たちは、そのためのサポートを惜しみません。
        </p>
      </div>

      <dl class="login-form">
        <dt class="login-form-caption">ユーザーID（メールアドレス）</dt>
        <dd class="login-form-input"><input type="text" name="inputUserid" v-model="loginId" :placeholder="userIdPlaceFolder" /></dd>
        <dt class="login-form-caption">パスワード</dt>
        <dd class="login-form-input"><input type="password" name="inputPassword" v-model="password" :placeholder="placeFolder" /></dd>
        <p v-if="isWithinThisYear">
         【2025年6月1日（日）以前に、J-Supportにご登録された方】<br>
          システムのアップデートに伴い、パスワードの再設定が必要です。<br>
          お済みでない方は、ご案内している仮パスワードでログインしていただき、再度パスワードの設定をお願いいたします。<br>
          ※パスワードが設定できない場合は、<a href="https://drive.google.com/file/d/1SdDfJy2edyQkf6B0BlIlaHUWAA7Ii5N1/view?usp=sharing" style="color: #005bac; text-decoration: underline;">こちら</a>をご確認ください。<br>
          ※ユーザーID（メールアドレス）・仮パスワードが分からない方は、<a href="mailto:jsupport-info@jmec.co.jp" style="color: #005bac; text-decoration: underline;">こちら</a>よりお問い合わせください。<br><br>
          【2025年6月2日（月）以降に、J-Supportにご登録された方】<br>
          パスワードの再設定は、不要です。<br>
        </p>
        <dd class="login-form-button">
          <a class="bt-login bt" v-on:click="requestOfSignIn">ログイン</a>
        </dd>
      </dl>

      <ul class="notice-list">
        <li class="notice-list-item">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScg_UxYM6JTPFo5StLNiRF-Jlm4W0-T_2b9H2fTk-6zZOfu5w/viewform">※新規アカウント登録はこちら</a>
        </li>
        <router-link to="/mailsending">
          <li class="notice-list-item">
            <a href="">※パスワードをお忘れの場合はこちら</a>
          </li>
        </router-link>
        <router-link to="/preloginfaq">
          <li class="notice-list-item">
            <a href="">※ログインできない場合はこちら</a>
          </li>
        </router-link>
      </ul>

      <div class="main-bottom-button">
        <a class="bt-back bt" style="padding: 0" :href="getLoginViewBackButtonLink()">{{ getLoginViewBackButtonWording()
        }}</a>
      </div>

      <!--【メインコンテンツここまで】-->
    </div>
    <!--/.main-->

    <Hooter />

    <div class="bt-pagetop hide">
      <a href="#top"><img :src="`@/${getIcoPagetopPath()}`" alt="" /></a>
    </div>

    <ResultModal ref="child_result_modal" />

    <!-- インジケーター -->
    <Indicator ref="indicator" />
  </div>
  <!--/.wrapper-->
</template>

<script>
import mixins from '../../mixins/AuthUtil';
import apiMixins from '../../mixins/ApiUtil';
import DeliveryMethods from '../../mixins/delivery-methods';
import ResultModal from '../../components/ResultModal';
import Indicator from '../../components/Indicator.vue';
import Header from '../../components/Header.vue';
import Hooter from '../../components/Hooter.vue';

export default {
  name: 'Login',
  mixins: [mixins, apiMixins],
  components: {
    ResultModal,
    Indicator,
    Header,
    Hooter
  },
  data() {
    return {
      loginId: '',
      password: '',
      userIdPlaceFolder: DeliveryMethods.PLACE_HOLDER_USER_ID,
      placeFolder: DeliveryMethods.PLACE_HOLDER_PASSWORD,
      currentDate: new Date()
    };
  },
  computed: {
    isWithinThisYear() {
      const now = this.currentDate;
      const endOfYear = new Date(now.getFullYear(), 11, 31, 23, 59, 59);
      return now <= endOfYear;
    },
  },
  mounted: function () {
    //  ページトップへ
    $(function () {
      var showFlag = false;
      var topBtn = $('.bt-pagetop');
      // スクロールが200に達したらボタン表示
      $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
          if (showFlag === false) {
            showFlag = true;
            topBtn.removeClass('hide');
          }
        } else {
          if (showFlag) {
            showFlag = false;
            topBtn.addClass('hide');
          }
        }
      });
    });
  },
  methods: {
    requestOfSignIn: async function () {
      if (!this.loginId || !this.password) {
        var message = '';
        if (!this.loginId) {
          message += 'ログインID';
        }
        if (!this.password) {
          message += (message === '' ? 'パスワード' : ', パスワード');
        }
        message += 'が入力されていません';
        this.$refs.child_result_modal.showResultSendInspectionModal(message);
        return;
      }

      // インジケーター表示
      this.$refs.indicator.doAjax();

      const signInResult = await this.signIn(this.loginId, this.password);
      console.log('Request SignIn Result : ', signInResult);
      if (signInResult.code === DeliveryMethods.LOGIN_FAILED_CODE_NOT_AUTHORIZED) {
        this.$refs.child_result_modal.showResultSendInspectionModal('ログインに失敗しました');
      } else if (signInResult.challengeName === 'NEW_PASSWORD_REQUIRED') {
        // セッションストレージにログインユーザーのオブジェクトを格納
        this.saveLoginUserIdToSessionStorage(this.loginId);
        // 初回認証時のパスワード変更画面へ遷移
        this.$router.push('/passwordSetting');
      } else {
        // 認証成功
        const result = await this.rewuestOfGetAccountInfo();
        await this.saveClinicCodeToCognito();
        this.requestAccessHistoryRegistration();
        this.$router.replace(result.data.data.is_agreed_terms_a === 1
          ? '/home'
          : '/terms');
      }
      this.$refs.indicator.onCancel();
    },
    /**
     * アカウント情報取得要求を行い、取得した情報をセッションストレージへ保存する
     * ※クリニックコードはcognitoのカスタム属性
     */
    rewuestOfGetAccountInfo: async function () {
      const result = await this.requestAccountInfoOfUserSite(this.loginId);
      console.log(result);
      if (result) {
        const param = {
          login_id: this.loginId,
          name: result.data.data.name,
          is_agreed_terms_a: result.data.data.is_agreed_terms_a,
          is_agreed_terms_b: result.data.data.is_agreed_terms_b,
          is_agreed_terms_c: result.data.data.is_agreed_terms_c,
          is_check_tutorial_a: result.data.data.is_check_tutorial_a,
          is_check_tutorial_b: result.data.data.is_check_tutorial_b,
          is_check_tutorial_c: result.data.data.is_check_tutorial_c
        };
        sessionStorage.setItem(DeliveryMethods.USER_SESSION_SAVE_KEY, JSON.stringify(param));
      }
      return result;
    },
    /**
     * Cognitoのカスタム属性にクリニックコードの保存を行う
     */
    saveClinicCodeToCognito: async function () {
      // Cognitonのカスタム属性にクリニックコードが保存されていない場合、クリニックコードの保存を行う
      const clinicCode = this.getClinicCodeForCognito();
      if (!clinicCode) {
        // クリニックコードをカスタム属性へ保存
        await this.updateClinicCodeOfCognito(result.data.data.clinic_code[0]);
      }
    },
    /**
     * アクセス履歴登録要求を行う
     */
    requestAccessHistoryRegistration: function () {
      const body = {
        user_id: this.loginId,
        domain: DeliveryMethods.DOMAIN
      };

      const result = this.requestAccessHistoryRegistrationOfUserSIte(body);

      console.log(result);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/login/Login.vue